module.exports = __webpack_public_path__ + "img/oneToOne.c0faa6ce.png";